<div>
<ds-tabs
         [activeTabId]="activeTab"
         (onActiveTabChange)="setActiveTab($event.tabId)">
  <ds-tab-head *ngFor="let tab of tabs" [tabId]="tab?.id" [activeTabId]="activeTab">
    <span class="ds-account__sidebar-link" [innerHTML]="tab.label"></span>
  </ds-tab-head>
  <ds-tab-content [tabId]="activeTab" [activeTabId]="activeTab">
    <db-image-optimize-media-library *ngIf="activeTab === 'media'"
                      [loading]="!!loading"
                      [inProgress]="!!inProgress"
                      [stats]="stats"
                      [pageLayout]="pageLayout"
                      [optimizeImagesStats]="optimizeImagesStats$ | async"
                      [currentSubscription]="currentSubscription"
                      [website]="website"
                      [websiteId]='website?.id'
                      [optimizedImages]="optimizedImages"
                      [optimizedPagesLoading]="optimizedPagesLoading"
                      [boosterPluginIsActive]="boosterPluginIsActive"
                      [currentScore]="currentScore"
                      (getReport)="getReportData(true)" (onClick)="contactUs()"></db-image-optimize-media-library>
    <db-image-optimizer-pages *ngIf="activeTab === 'pages'"
                              [statsLoading]="!!loading"
                              [stats]="stats"
                              [optimizedPages]="optimizedPages"
                              [optimizedPagesLoading]="optimizedPagesLoading"
                              [boosterPluginIsActive]="boosterPluginIsActive"
                              [currentScore]="currentScore"
                              (getReport)="getReportData(true)" (onClick)="contactUs()"></db-image-optimizer-pages>
  </ds-tab-content>
</ds-tabs>
</div>
